<template>
  <div class="message-list-page">
    <h1>全部提醒</h1>
    <dl v-for="(ms, k) in messages">
      <dt>{{k | moment('YYYY-MM-DD')}}</dt>
      <dd class="clearfix" v-for="m in ms">
        <div class="icon float-left">
          <i class="ico ico-txt"></i>
        </div>
        <div class="txt" v-html="m.content">
        </div>
      </dd>
    </dl>
    <div class="yd-pagination" v-if="messages && totalCount > 0">
      <el-pagination
        :page-size="form.limit"
        :pager-count="5"
        :current-page.sync="form.page"
        layout="prev,pager, next"
        next-text="下一页"
        prev-text="上一页"
        :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '../../services/api.js'
let _ = require('lodash')

export default {
  name: 'AddAddress',
  components: {
  },
  computed: {
  },
  data () {
    return {
      messageType: null,
      messages: null,
      countFun: null,
      getFun: null,
      totalCount: null,
      form: {
        page: 1,
        limit: 10
      }
    }
  },
  created () {
    // this.messageType = this.$route.params.type
    // if (this.messageType == 'buyer') {
    //   this.countFun = 'countMessagesForBuyer'
    //   this.getFun = 'getMessagesForBuyer'
    // } else {
    //   this.countFun = 'countMessagesForSingle'
    //   this.getFun = 'getMessagesForSingle'
    // }
    this.countFun = 'countMessages'
    this.getFun = 'getMessages'
    this.countMessages()
    this.getMessages()
  },
  methods: {
    async countMessages () {
      let { body } = await api[this.countFun](this)
      let result = body.result || 0
      this.totalCount = Number(result)
    },
    async getMessages () {
      let { body } = await api[this.getFun](this, this.form)
      let result = body.result || []
      this.messages = _.groupBy(result, (v) => {
        return this.$moment(v.create_time).format('YYYY-MM-DD')
      })
    }
  },
  watch: {
    form: {
      handler: function (val, oldVal) {
        this.getMessages()
        this.countMessages()
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.message-list-page {
  width: 1140px;
  margin: 0 auto;
}
h1 {
  font-size:22px;
  font-family:PingFangSC-Regular;
  color:rgba(51,51,51,1);
  line-height:30px;
}
dt {
  color: #666666;
  padding: 20px 0 10px;
  border-bottom: 1px solid #D7D7D7;
}

.icon {
  width: 40px;
}
.txt {
  margin-left: 40px;
}

dd {
  border-bottom: 1px dashed #D7D7D7;
  padding: 17px 0;
  line-height: 25px;
}

.yd-pagination {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user_center/Messages.vue